import { Component, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Loader } from './shared/components/loader/loader';
import { CommonModule } from '@angular/common';
import { Header } from './shared/components/header/header';
import { Sidebar } from './shared/components/sidebar/sidebar';
import { Observable, Subject, takeUntil } from 'rxjs';
import { User } from '@angular/fire/auth';
import { AuthService } from './core/authentication/auth';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { FormsModule } from '@angular/forms';
import { Layout } from './core/ui/layout';
import { LoaderService } from './core/ui/loader';
import { AlertService } from './core/ui/alert';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [CommonModule, RouterModule, Loader, Header, Sidebar, MatSidenavModule, FormsModule],
	templateUrl: './app.html',
	styleUrl: './app.css'
})

export class App {
	currentUser$: Observable<User | null>;

	public isMobile: boolean = false;

	private _unsubscribeAll: Subject<any> = new Subject<any>();

	@ViewChild('sidenav') sidenav!: MatSidenav;

  	constructor(private authService: AuthService, private layoutService: Layout, private loaderService: LoaderService, private alertService: AlertService, private router: Router) {
		this.currentUser$ = this.authService.user$;
		
		this.layoutService.isMobile$.pipe(takeUntil(this._unsubscribeAll)).subscribe(isMobileValue => {
			this.isMobile = isMobileValue;
		});
	}

	toggleSidenav() {
		this.sidenav.toggle();
	}

	async onLogout(): Promise<void> {
		try {
			await this.authService.logout();

			this.loaderService.hide();
			this.router.navigate(['/']);
		} catch(error: any) {
			this.loaderService.hide();
			this.alertService.error(error.message, 'Error');
		}
	}

	ngOnDestroy(): void {
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}
}